<template>
  <div>
    <Header/>
    <div class="container">
      <a href="#" class="flex-v-center mb-1" @click.prevent="$router.back()" v-if="!isAndroid">
        <svg class="rotate-180 mr-1" width="16" height="16" viewBox="0 0 16 16" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M0 8H14M14 8L6.92857 1M14 8L6.92857 15" stroke="#9485EF" stroke-width="2"/>
        </svg>
        {{ $lang.messages.back }}
      </a>
      <div class="device-wrapper">
        <div class="content-block-item">
          <div class="profile-content">
            <ProfileSettings/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {mapState} from "vuex";
import saveSetting from "@/components/mixins/saveSetting";
import Header from "@/components/Header";
import ProfileSettings from "@/components/ProfileSettings";


export default {
  name: 'NewProfile',
  mixins: [saveSetting],
  data() {
    return {
      isAndroid: window.Android
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
      accountData: state => state.accountData
    })
  },
  methods: {

  },
  components: {
    Header,
    ProfileSettings
  }
}
</script>
